import React, { useMemo } from 'react';

import COLORS from '../../../constants/colors.constants';

import StatCard from '../../common/StatCard/StatCard';
import usePrometheusQuery from '../../../utils/hooks/use_prometheus_query_without_range';
import { percentFormatter } from '../../../utils/formatters';

import ModelsIcon from '../../common/icons/ModelsIcon';
import Icon from '../../common/icons/Icon';
import { formatUnitRatioForStorage } from '../../../utils/prometheus_utils';

const getTotalModelStorage = () => {
  return 'kubelet_volume_stats_capacity_bytes{persistentvolumeclaim="minio"}'
}

// Above 100% - normal because of model duplication - Cyril can provide context as needed
const getUsedModelStorage = () => {
  return 'kubelet_volume_stats_used_bytes{persistentvolumeclaim="minio"}';
}

export const useTotalModelStorage = () => {
  const query = useMemo(() => {
    return getTotalModelStorage();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const useRequestedModelStorage = () => {
  const query = useMemo(() => {
    return getUsedModelStorage();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

const ModelsIconComponent = () => {
  return <Icon fill={COLORS.brand} icon={ModelsIcon} size={24} useTailwindSizing />
}

export const ContextualModelStorageCard = () => {
  const requestedResponse = useRequestedModelStorage()
  const requestedData = requestedResponse?.chartData;
  const requestedValue = requestedData?.length ? requestedData[1] : 0;

  const totalResponse = useTotalModelStorage()
  const totalData = totalResponse?.chartData;
  const totalValue = totalData?.length ? totalData[1] : 0;

  const subVal = formatUnitRatioForStorage(requestedValue, totalValue);
  const subtitle = `Used ${subVal} Allocated`;

  const content = totalValue ? percentFormatter.format(requestedValue / totalValue) : 0;
  const isLoading = requestedResponse?.isLoading || totalResponse?.isLoading;

  return (
    <StatCard
      className=""
      icon={ModelsIconComponent}
      header="Total Current Artifact Storage"
      subtitle={subtitle}
      content={`${content}`}
      isLoading={isLoading}
    />
  )
}

export default ContextualModelStorageCard;
